import React, { useState } from 'react';
import { Card, Button, Accordion, Row, Col, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
const TailoringDetail = () => {
    const navigate = useNavigate(); 

    const handleScrollToContact = () => {
        // Navigate to contact page and append hash for scrolling to form
        navigate('/tailoring-form');
    };



    return (
        <>
            <div className="bg-dark text-white">
      {/* Hero Section */}
      <Container className="py-5">
        <Row className="align-items-center">
          <Col sm={12} md={12} lg={6}>
            <h1 className="fw-bold">Tailoring Course</h1>
            <p className="mt-3">
            Tailoring Course is designed to provide students with the knowledge and skills required to become professional tailors or start their own tailoring business. The program focuses on both theoretical knowledge and practical training, enabling students to master the art of stitching, designing, and finishing garments.
            </p>
            <div className="d-flex gap-3 mt-4">
              <span className="badge bg-secondary p-2"><i class="fa-solid fa-clock-rotate-left" style={{color: "#ffffff"}}></i> 6 Month Course</span>
              <span className="badge bg-secondary p-2"><i class="fa-regular fa-hourglass-half" style={{color: "#ffffff"}}></i> 1 Hour Session</span>
              <span className="badge bg-secondary p-2"><i class="fa-solid fa-book-open" style={{color: "#ffffff"}}></i> 50+ Lessons</span>
            </div>
            <Button variant="primary" className="mt-4 p-3 px-5" onClick={handleScrollToContact}>
             Apply Now
            </Button>
          </Col>
          
        </Row>
      </Container>

      {/* Course Details Section */}
      <Container fluid className="bg-light text-dark py-5">
        <Row>
          <Col sm={12} md={12} lg={2} className="ps-5">
            <ul className="list-unstyled">
              <li className="fw-bold">Course Overview</li>
              <li>What you'll learn</li>
              <li>Syllabus</li>
              <li>Course Instructor</li>
              <li>Projects</li>
              <li>Student Review</li>
            </ul>
          </Col>
          <Col sm={12} md={12} lg={10} className="px-5">
            <h2 className="fw-bold">Tailoring Course</h2>
            <hr />
            <p>
            In tailoring, measurement and cutting define accuracy, while fabric selection shapes the final design. Pattern drafting guides stitching, seams, darts, and pleats into structure. Tools like scissors, tailor’s chalk, and sewing machines support precision. Hemming, lining, and pressing complete garments, ensuring comfort, fit, and professional finishing in every creation.
            </p>
            <h3 className="fw-bold">Foundational Skills</h3>
            <hr />
            <p>            <p>Learn sewing, cutting, pattern drafting, fabric handling, and garment construction. Master stitching, hemming, finishing, and professional tailoring techniques for perfect-fitting clothes. </p> </p>

            <div className="py-5">
      {/* What You'll Learn Section */}
      <h2 className="fw-bold">What you'll learn</h2>
      <hr />
      <Row className="gy-4">
        <Col sm={12} md={12} lg={3}>
          <h4 style={{color:'#e69d00'}} className="fw-bold">01</h4>
          <h5 className="fw-bold">Basic Sewing Techniques</h5>
          <p>Learn hand stitches, machine operation, hemming, and beginner-friendly garment construction.</p>
        </Col>
        <Col sm={12} md={12} lg={3}>
          <h4 className="fw-bold" style={{color:'#e69d00'}}>02</h4>
          <h5 className="fw-bold">Pattern Drafting Skills</h5>
          <p>Understand body measurements, create patterns, and shape fabric into garments.</p>
        </Col>
        <Col sm={12} md={12} lg={3}>
          <h4 className="fw-bold" style={{color:'#e69d00'}}>03</h4>
          <h5 className="fw-bold">Fabric Handling & Cutting</h5>
          <p>Identify fabric types, cut accurately, and prepare materials for sewing.</p>
        </Col>
        <Col sm={12} md={12} lg={3}>
          <h4 className="fw-bold" style={{color:'#e69d00'}}>04</h4>
          <h5 className="fw-bold">Garment Finishing Methods</h5>
          <p> Practice pressing, seam finishing, and detailing for professional-looking final garments.</p>
        </Col>
      </Row>

      {/* Syllabus Section */}
      <h2 className="fw-bold mt-5">Syllabus</h2>
      <hr />
      <Row className="gy-4">
        <Col sm={12} md={12} lg={6}>
          <h4 className=""><span style={{color:'#e69d00'}}>01</span> Sewing Basics</h4>
         
          <ul className="section-title">
            <li>Stitching</li>
            <li>Hemming</li>
            <li>Seam</li>
          </ul>
        </Col>
        <Col sm={12} md={12} lg={6}>
          <h4 className=""><span style={{color:'#e69d00'}}>02</span> Pattern Making</h4>
          <h5 className="fw-bold"></h5>
          <ul className="section-title">
            <li>Drafting</li>
            <li>Measurements</li>
            <li>Templates</li>
          </ul>
        </Col>
        <Col sm={12} md={12} lg={6}>
          <h4 className=""><span style={{color:'#e69d00'}}>03</span>Fabric & Materials</h4>
          <h5 className="fw-bold"></h5>
          <ul className="section-title">
            <li>Cotton</li>
            <li>Silk </li>
            <li>Linen</li>
          </ul>
        </Col>
        <Col sm={12} md={12} lg={6}>
          <h4 className=""><span style={{color:'#e69d00'}}>04</span> Garment Finishing</h4>
          <h5 className="fw-bold"></h5>
          <ul className="section-title">
            <li>Pressing</li>
            <li>Lining</li>
            <li>Embroidery</li>
          </ul>
        </Col>
      </Row>
    </div>
          </Col>
        </Row>
        
      </Container>
      
      
    </div>

    
        </>
    );
};

export default TailoringDetail;
